import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Socket, SocketIoConfig } from 'ngx-socket-io';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

// const URL = 'https://api.localcannabisco.ca/chat';

const URL = environment.chatUrl

@Injectable({
  providedIn: 'root'
})
export class SocketService {

  constructor(
    private socket: Socket,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {

  }

  connectOrGet(): any {
    if (isPlatformBrowser(this.platformId)) {
      if (this.socket !== null && this.socket instanceof Socket) {
        return this.socket;
      } else {
        const config: SocketIoConfig = { url: URL, options: {} };
        this.socket = new Socket(config);        
        return this.socket;
      }
    }
  }



  emit(event: string, data: any) {
    this.socket.emit(event, data);
  }
  on(event: string) {
    return new Observable((subscriber) => {
      this.socket.on(event, (msg) => {
        subscriber.next(msg);
      });
    });
  }

}
